import React, { Fragment, useEffect, useState, useMemo } from "react";
import { connect } from "react-redux";
import MainWrapper from "../../../MainWrapper";
import { Link, useNavigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { ic_arrow_back  } from 'react-icons-kit/md';
import { Accordion, Table, Button, Row, Col, Form } from "react-bootstrap";
import { toast } from 'react-toastify';
import { FaTrash } from "react-icons/fa";
import ConfirmModal from "./ConfirmModal";

import {
  CUSTOMER_APPROVAL_LIST_REQUEST,
  CUSTOMER_APPROVAL_UPDATE_REQUEST,
  CUSTOMER_APPROVAL_REJECT_REQUEST,
  CUSTOMER_APPROVAL_DELETE_REQUEST,
  PROPERTY_LIST_REQUEST,
  ADD_NEW_PROPERTY_REQUEST,
  CUSTOMER_PROPERTY_DELETE_REQUEST
} from "../../../../_utils/constants/CustomerApproval";
import Input from "../../../elements/CustomInput";

const CustomerApproval = ({
  auth: { auth, isAuthenticated },
  CustomerApproval: { 
    customerApprovalList, 
    errors, 
    isLoading, 
    customerUpdationData, 
    customerRejectedData, 
    customerDeletedData,
    customerExistData,
    propertyList,
    propertyDeletedData,
    propertyUpdatedData
  },
  fetchCustomerApprovalList,
  updateCustomerApprovalStatus,
  rejectCustomerApprovalRequest,
  deleteCustomerApprovalRequest,
  fetchPropertyAlreadyExist,
  addNewProperty,
  deleteCustomerPropertyRequest
}) => {

  //state declaration
  const [customerApprovalData, setCustomerApprovalData] = useState()
  const [listParamState, setListParamState] = useState({
		"firstName": "",
		"lastName": "",
		"email": "",
		"pageIndex": 0,
		"pageSize": 0
	});
  const [responseData, setResponseData] = useState()
  const [responseDeleteData, setResponseDeleteData] = useState()
  const [isLoaded, setIsLoaded] = useState(false)
  const approvedMessage = "Sign up request for customer is successfully approved. Email with verification link will be sent to customer."
  const rejectedMessage = "Sign up request is successfully rejected."
  // const [selectedPropertyIds, setSelectedPropertyIds] = useState([]) 
  const [tempRows, setTempRows] = useState({}); // {index: [rows]}
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredProps, setFilteredProps] = useState([]);
  const [deletePropertyModalOpen, setDeletePropertyModalOpen] = useState(false);
  const [deleteCustomerModalOpen, setDeleteCustomerModalOpen] = useState(false);
  const [deletePropertyData, setDeletePropertyData] = useState({});
  const [deleteCustomerData, setDeleteCustomerData] = useState({});
  const [selectedCustomer, setSelectedCustomer] = useState();
  const navigate = useNavigate();

  // function to handle customer approval list api call
  useEffect(() => {
    if (!isAuthenticated) {
			navigate("/login")
		}
    if (isAuthenticated) {
      fetchCustomerApprovalList(auth[0].token, listParamState)
    }
  }, [isAuthenticated, auth, listParamState])

  // function to handle customer approval list
  useEffect(() => {
    setCustomerApprovalData(customerApprovalList)
  }, [customerApprovalList])

  // handle customer approval updation
  useEffect(() => {
    if(!_.isEmpty(customerUpdationData)) {
      setResponseData(customerUpdationData)
    }
  }, [customerUpdationData])

  // handle customer rejection
  useEffect(() => {
    if(!_.isEmpty(customerRejectedData)) {
      setResponseData(customerRejectedData)
    }
  }, [customerRejectedData])

  // handle response data
  useEffect(() => {
    if (customerExistData) {
      toast.error(customerExistData)
    }
  }, [customerExistData])

  //handle response data
  useEffect(() => {
    if (responseData && isLoaded) {
      if (responseData[0] === "Rejected") {
        toast.success(rejectedMessage)
        setIsLoaded(false)
      } else if (responseData[0] === "saved") {
        toast.success(approvedMessage)
        setIsLoaded(false)
      } else {
        toast.success(responseData[0])
        setIsLoaded(false)
      }
      fetchCustomerApprovalList(auth[0].token, listParamState)
    }
  }, [responseData])

  // handle api errors
  useMemo(() => {
    if(!_.isEmpty(errors)) {
      toast.error(errors?.data?.result ? errors?.data?.result[0]: "Error")
    }
  }, [errors])

  // handle delete customer api data
  useEffect(() => {
    if(customerDeletedData && customerDeletedData.length > 0) {
      setResponseDeleteData(customerDeletedData)
    }
  }, [customerDeletedData])

  useEffect(() => {
    if (responseDeleteData && isLoaded) {
      if (responseDeleteData[0] === 'Not Delete') {
        toast.success("Customer not deleted")
        setIsLoaded(false)
      } else {
        toast.success(customerDeletedData[0])
        setIsLoaded(false)
      }
      fetchCustomerApprovalList(auth[0].token, listParamState)
    }
  }, [responseDeleteData])

  // function called on any filter value change
	const handleFilterChange = (e) => {
		const { id, value } = e.target;
		setListParamState(
			{
				...listParamState,
				[id]: value
			}
		)
	}

  // handle approve click
  const handleApproveClick = (data) => {
    setIsLoaded(true)
    updateCustomerApprovalStatus(auth[0].token, data)
  }

  // handle reject click
  const handleRejectClick = (data) => {
    setIsLoaded(true)
    rejectCustomerApprovalRequest(auth[0].token, data)
  }

  //handle customer delete
  const handleDelete = () => {
    setIsLoaded(true)
    console.log('--handleDelete-')
    if(deleteCustomerData) {
      deleteCustomerApprovalRequest(auth[0].token, deleteCustomerData)
      setDeleteCustomerData({})
      setDeleteCustomerModalOpen(false)
    }
  }

  const handleCustomerDelete = (data) => {
    setDeleteCustomerModalOpen(true);
    setDeleteCustomerData(data);
  }
  const handleCustomerDeleteSubmit = () => {
    handleDelete()
  }
  
   // Debounce search
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm) {
        fetchPropertyAlreadyExist(auth[0].token, searchTerm.toLowerCase())
        // const filtered = allProperties.filter((p) =>
        //   p.propertyName.toLowerCase().includes(searchTerm.toLowerCase())
        // );
        // setFilteredProps(filtered);
      } else {
        setFilteredProps([]);
      }
    }, 300);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  useEffect(() => {
    setFilteredProps(propertyList)
  }, [propertyList])

  useEffect(() => {
    // Update newly added propery id after adding new property
    setCustomerApprovalData(prev =>
      prev.map((user, idx) =>
        idx === selectedCustomer
          ? {
              ...user,
              customerProperty: [...user.customerProperty, ...propertyUpdatedData]
            }
          : user
      )
    );
    setSelectedCustomer('');
    setTempRows({});
  }, [propertyUpdatedData])

  const handleAddRow = (index) => {
    const newRow = { shipToPropertyName: "", data: {} };
    setTempRows((prev) => ({
      ...prev,
      [index]: [...(prev[index] || []), newRow],
    }));
  };

  const hideConfirmDeleteModal = () => {
    setDeletePropertyModalOpen(false)
  }
  const hideCustomerDeleteModal = () => {
    setDeleteCustomerModalOpen(false)
    setDeleteCustomerData({})
  }
  
  const handleConfirmDeleteSubmit = () => {
    const {propertyId, customerIdx} = deletePropertyData;
    if(propertyId){
      deleteCustomerPropertyRequest(auth[0].token, propertyId)
      setCustomerApprovalData(prev =>
        prev.map((user, idx) =>
          idx === customerIdx
            ? {
                ...user,
                customerProperty: user.customerProperty.filter(
                  prop => prop.customerSignupPropertyId !== propertyId
                )
              }
            : user
        )
      );
      setDeletePropertyModalOpen(false)
      setDeletePropertyData({})
    }
  }

  const handleRemoveRow = (delType, index, i=0) => {
    if(delType === 'P'){
      console.log('--P--');
      setDeletePropertyData({
        propertyId: index,
        customerIdx: i
      })
      setDeletePropertyModalOpen(true)
    }
    else{
      console.log('--T--')
      const updated = [...(tempRows[index] || [])];
      updated.splice(i, 1);
      setTempRows({ ...tempRows, [index]: updated });
    }
  };

  const handlePropertySelect = (rowIndex, prop, userIndex, uData) => {
    const updated = [...(tempRows[userIndex] || [])];
    updated[rowIndex] = { shipToPropertyName: prop.shipToPropertyName, data: prop, customer:uData };
    setTempRows({ ...tempRows, [userIndex]: updated });
    setSearchTerm(""); // Clear after selection
    setFilteredProps([]);
  };

  const handleSave = (userIndex) => {
    const rowsToSave = tempRows[userIndex];

    const newPropList = rowsToSave
      .filter(item => item?.customer?.customerSignupId)
      .map((item, index) => ({
      CustomerSignupId: item.customer.customerSignupId,
      PropertyName: item.data.shipToPropertyName,
      ManagementCompany: item.data.shipToManagementCompany,
      Address: item.data.shipToAddress,
      City: item.data.shipToCity,
      State: item.data.shipToState,
      Zip: item.data.shipToZip,
      PhoneNo: item.data.shipToPhone,
      ContactInfoID: item.data.contactInfoId,
    }));

    if(newPropList.length > 0){
      let tmpList = {
        'CustomerProperty': newPropList
      };
      setSelectedCustomer(userIndex)
      addNewProperty(auth[0].token, tmpList)
    }
  };

  return (
    <Fragment>
      <MainWrapper>
      {isLoading ? (<div className="loading-container"><div className="spinner-border"></div></div>) : null}
      <div className="container">
        <div className="sub-header mt-5 mb-3">
          <h2>Customer approval</h2>
          <Link className="btn btn-primary me-1" to="/admin"><Icon icon={ic_arrow_back} />Back</Link>
        </div>
        
        <div className="p-3 bg-light customer-approval-filter">
          <Row>
            <Col md={4}><Input label={`First Name`} ids={`firstName`} value={listParamState.firstName} validate={false} handleChange={handleFilterChange} /></Col>
            <Col md={4}><Input label={`Last Name`} ids={`lastName`} value={listParamState.lastName} validate={false} handleChange={handleFilterChange} /></Col>
            <Col md={4}><Input label={`Email`} ids={`email`} value={listParamState.email} validate={false} handleChange={handleFilterChange} /></Col>
          </Row>
        </div>
        <Accordion defaultActiveKey="0">
          {!_.isEmpty(customerApprovalData) ? _.map(customerApprovalData, (data, index) => (
            <Accordion.Item eventKey={index}>
              <Accordion.Header key={index}>{data.firstName} {data.lastName} - {data.email} - {data.role}</Accordion.Header>
              <Accordion.Body>
                <Table bordered responsive className="mb-3">
                  <thead>
                    <tr>
                      <th>Property Name</th>
                      <th>Management Company</th>
                      <th>Address</th>
                      <th>City</th>
                      <th>State</th>
                      <th>Zip</th>
                      <th>Phone No.</th>
                      <th></th>
                    </tr>
                  </thead>
                    <tbody>
                      {!_.isEmpty(data.customerProperty) ? _.map(data.customerProperty, (value, position) => (
                      <tr key={position}>
                        <td>{_.get(value, "propertyName", "")}</td>
                        <td>{_.get(value, "managementCompany", "")}</td>
                        <td>{_.get(value, "address", "")}</td>
                        <td>{_.get(value, "city", "")}</td>
                        <td>{_.get(value, "state", "")}</td>
                        <td>{_.get(value, "zip", "")}</td>
                        <td>{_.get(value, "phoneNo", "")}</td>
                        <td>
                          <FaTrash
                            style={{ cursor: "pointer", color: "red" }}
                            onClick={() => handleRemoveRow('P', value.customerSignupPropertyId, index)}
                          />
                        </td>
                      </tr>
                      )) : ""}
                      {(tempRows[index] || []).map((row, i) => (
                        <tr key={`new-${i}`}>
                          <td>
                            {row.shipToPropertyName ? (
                              row.shipToPropertyName
                            ) : (
                              <>
                                <Form.Control
                                  type="text"
                                  placeholder="Search property"
                                  value={searchTerm}
                                  onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                {filteredProps.length > 0 && (
                                  <div
                                    style={{
                                      background: "#f9f9f9",
                                      position: "absolute",
                                      zIndex: 1000,
                                      border: "1px solid #ccc",
                                      width: "200px",
                                    }}
                                  >
                                    {filteredProps.map((prop, idx) => (
                                      <div
                                        key={idx}
                                        style={{
                                          padding: "4px 8px",
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          handlePropertySelect(i, prop, index, data)
                                        }
                                      >
                                        {prop.shipToPropertyName}
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </>
                            )}
                          </td>
                          <td>{row.data?.shipToManagementCompany || ""}</td>
                          <td>{row.data?.shipToAddress || ""}</td>
                          <td>{row.data?.shipToCity || ""}</td>
                          <td>{row.data?.shipToState || ""}</td>
                          <td>{row.data?.shipToZip || ""}</td>
                          <td>{row.data?.shipToPhone || ""}</td>
                          <td>
                            <FaTrash
                              style={{ cursor: "pointer", color: "red" }}
                              onClick={() => handleRemoveRow('T', index, i)}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                </Table>
                <div className="mb-3">
                  <Button
                    variant="success"
                    className="me-2"
                    onClick={() => handleAddRow(index)}
                  >
                    Add Property
                  </Button>
                  {tempRows[index]?.length > 0 && (
                    <Button
                      variant="primary"
                      className="me-2"
                      onClick={() => handleSave(index)}
                    >
                      Save
                    </Button>
                  )}
                </div>
                <div>
                  Status: {_.get(data, "status", "")}
                </div>
                <Button className="me-2" variant="primary" disabled={data?.status === "Pending Request" ? false : true} onClick={()=>handleApproveClick(data)}>Approve</Button>
                <Button className="me-2" variant="secondary" disabled={data?.status === "Pending Request" ? false : true} onClick={()=>handleRejectClick(data)}>Reject</Button>
                <Button className="me-2" variant="danger" onClick={()=>handleCustomerDelete(data)}>Delete</Button>
              </Accordion.Body>
            </Accordion.Item> )) : null
          }
        </Accordion>
      </div>
      {deletePropertyModalOpen ?
        <ConfirmModal
          show={deletePropertyModalOpen}
          onHide={hideConfirmDeleteModal}
          onConfirm={handleConfirmDeleteSubmit}
          title="Remove Customer Property?"
          message="Are you sure?"
          dangerNote="Access to this property will be removed for this customer."
        /> : ""
      }
      {deleteCustomerModalOpen ?
        <ConfirmModal
          show={deleteCustomerModalOpen}
          onHide={hideCustomerDeleteModal}
          onConfirm={handleCustomerDeleteSubmit}
          title="Delete Customer?"
          message="Are you sure?"
          dangerNote="* Customer will be deleted."
        /> : ""
      }
      </MainWrapper>
    </Fragment>
  )
}

const mapStateToProps = ({ auth, CustomerApproval }) => {
  return {
    auth, CustomerApproval
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    fetchCustomerApprovalList: (token, listParamState) => dispatch({ type: CUSTOMER_APPROVAL_LIST_REQUEST, token, listParamState }),
    updateCustomerApprovalStatus: (token, data) => dispatch({ type: CUSTOMER_APPROVAL_UPDATE_REQUEST, token, data }),
    rejectCustomerApprovalRequest: (token, data) => dispatch({ type: CUSTOMER_APPROVAL_REJECT_REQUEST, token, data }),
    deleteCustomerApprovalRequest: (token, data) => dispatch({ type: CUSTOMER_APPROVAL_DELETE_REQUEST, token, data }),
    fetchPropertyAlreadyExist: (token, data) => dispatch({ type: PROPERTY_LIST_REQUEST, token, data }),
    addNewProperty: (token, data) => dispatch({ type: ADD_NEW_PROPERTY_REQUEST, token, data }),
    deleteCustomerPropertyRequest: (token, data) => dispatch({ type: CUSTOMER_PROPERTY_DELETE_REQUEST, token, data })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerApproval);